import { useEffect } from "react";

export default function LogoutedUI(){
    useEffect(() => {
        if (!document) return;

        document.body.classList.add('dark_green');

        return () => {
            document.body.classList.remove('dark_green');
        };
    }, []);
    
    return(
        <>
            <div className="text-dark">
                <strong className="masthead-notice rounded-3 p-2">Что нового в Asakura Wiki</strong>
                <h2>Внедрение ИИ для контрмер nmngyuri</h2>
                <p>Чтобы уничтожить силы, защищающие nmngyuri</p>
            </div>
            <h1 className="mb-3 fw-semibold lh-1">Создайте свою собственную вики с<br/>множеством функций Asakura Wiki.</h1>
            <p className="lead mb-4">
                <strong className="text-brand block md:ml-0">Это мощный, масштабируемый и многофункциональный сервис аренды вики.</strong><br/>
                <span className="block text-foreground">askrEditor, воспользуйтесь преимуществами предварительно созданной системы сетки и компонентов,</span><br/>
                С волшебно мощными оригинальными вики-плагинами<br/><strong className="text-brand block md:ml-0">Вы можете оживить свою вики.</strong>
            </p>
            <div className="flex items-center gap-2">
                <a
                    className="relative justify-center cursor-pointer inline-flex items-center space-x-2 text-center font-regular ease-out duration-200 rounded-md outline-none transition-all outline-0 focus-visible:outline-4 focus-visible:outline-offset-1 border bg-brand-400 dark:bg-brand-500 hover:bg-brand/80 dark:hover:bg-brand/50 text-foreground border-brand-500/75 dark:border-brand/30 hover:border-brand-600 dark:hover:border-brand focus-visible:outline-brand-600 data-[state=open]:bg-brand-400/80 dark:data-[state=open]:bg-brand-500/80 data-[state=open]:outline-brand-600 text-sm px-4 py-2 h-[38px]"
                    href="https://sakitibi.github.io/selects/e38182e38195e382afe383a957696b69e383ade382b0e382a4e383b3"
                >
                    <span className="truncate">Создание нового аккаунта 14nin</span>
                </a>
            </div>
        </>
    );
}